'use strict';

var React = require('react');
var withStyles = require('../../Styles/withStyles.js');
var Toolbar = require('../../../node_modules/@material-ui/core/esm/Toolbar/Toolbar.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    height: '100vh'
  },
  children: {
    flex: '1 1 100%'
  }
};

var ToolbarContent = function ToolbarContent(_ref) {
  var children = _ref.children,
      classes = _ref.classes;
  return React__default["default"].createElement("div", {
    className: classes.container
  }, React__default["default"].createElement(Toolbar["default"], null), React__default["default"].createElement("div", {
    className: classes.children
  }, children));
};

var ToolbarContent$1 = withStyles["default"](styles)(ToolbarContent);

module.exports = ToolbarContent$1;
